import { render, staticRenderFns } from "./change-item.vue?vue&type=template&id=587eb3b3&scoped=true&lang=pug&"
import script from "./change-item.vue?vue&type=script&lang=js&"
export * from "./change-item.vue?vue&type=script&lang=js&"
import style0 from "./change-item.vue?vue&type=style&index=0&id=587eb3b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587eb3b3",
  null
  
)

export default component.exports